import '@babel/polyfill';
import Notifications from '@kyvg/vue3-notification';
import { createApp } from 'vue';
import { createStore } from 'vuex';
import VuexPersistence from 'vuex-persist';
import { io } from 'socket.io-client';
import VueSocketIO from 'vue-socket.io';
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome';
import { library } from '@fortawesome/fontawesome-svg-core';
import {
    faAngleDoubleLeft,
    faAngleDoubleRight,
    faAngleDown,
    faAngleLeft,
    faAngleRight,
    faArrowDown,
    faArrowLeft,
    faArrowUp,
	faArrowTurnUp,
	faAsterisk,
    faBan,
    faBars,
    faBoltLightning,
    faBook,
    faCaretDown,
    faCheck,
    faCheckCircle,
    faChevronDown,
    faChevronLeft,
    faChevronRight,
    faChevronUp,
    faClock,
    faCog,
    faCoins,
    faComment,
    faComments,
    faCompressArrowsAlt,
    faCopyright,
    faCrown,
    faEllipsisVertical,
    faEnvelope,
    faExclamationCircle,
	faExternalLink,
    faFeather,
    faFlag,
    faHandPaper,
    faHeart,
    faHorseHead,
    faHourglass,
    faHourglassHalf,
    faInfoCircle,
    faKeyboard,
    faLock,
    faLongArrowAltDown,
    faLongArrowAltUp,
    faMinus,
    faMobile,
    faPause,
    faPauseCircle,
    faPersonRunning,
    faPlay,
    faPlayCircle,
    faPlus,
    faPlusSquare,
    faQuestionCircle,
    faRecycle,
    faReply,
    faRightLeft,
    faScroll,
    faSearch,
    faSearchMinus,
    faSearchPlus,
    faShare,
    faShield,
    faSignInAlt,
    faSignOutAlt,
    faSkull,
    faSlash,
    faSmile,
    faSortDown,
    faSyncAlt,
    faTimes,
    faTimesCircle,
    faTint,
    faTrophy,
    faUndoAlt,
    faUser,
    faUserPlus,
    faVolumeMute,
    faVolumeUp,
    faWindowMinimize,
} from '@fortawesome/free-solid-svg-icons';
import ActionModal from '@/components/ActionModal/ActionModal';
import ActionsLog from '@/components/ActionsLog/ActionsLog';
import AltPlayerLabel from '@/components/AltPlayerLabel/AltPlayerLabel';
import AltUnitsModal from '@/components/AltUnitsModal/AltUnitsModal';
import AltUnitsSelector from '@/components/AltUnitsSelector/AltUnitsSelector';
import BishopToggle from '@/components/BishopToggle/BishopToggle';
import Board from '@/components/Board/Board';
import BlockUserModal from '@/components/BlockUserModal/BlockUserModal';
import CancelModal from '@/components/CancelModal/CancelModal';
import Card from '@/components/Card/Card';
import Cards from '@/components/Cards/Cards';
import Chat from '@/components/Chat/Chat';
import CircularCountdown from '@/components/CircularCountdown/CircularCountdown';
import Contact from '@/components/Contact/Contact';
import ConversationCard from '@/components/ConversationCard/ConversationCard';
import CountUp from '@/components/CountUp/CountUp';
import DecreeCard from '@/components/DecreeCard/DecreeCard';
import DecreeMarker from '@/components/DecreeMarker/DecreeMarker';
import DecreeWidget from '@/components/DecreeWidget/DecreeWidget';
import DecreesBar from '@/components/DecreesBar/DecreesBar';
import DecreesModal from '@/components/DecreesModal/DecreesModal';
import DirectMessagesWidget from '@/components/DirectMessagesWidget/DirectMessagesWidget';
import DisqualifiedAlert from '@/components/DisqualifiedAlert/DisqualifiedAlert';
import DraftArea from '@/components/DraftArea/DraftArea';
import FortLayout from '@/components/FortLayout/FortLayout';
import Icon from '@/components/Icon/Icon';
import Leaderboard from '@/components/Leaderboard/Leaderboard';
import Loader from '@/components/Loader/Loader';
import Login from '@/components/Login/Login';
import Matches from '@/components/Matches/Matches';
import RecentMatches from '@/components/RecentMatches/RecentMatches';
import MiniDirectMessages from '@/components/MiniDirectMessages/MiniDirectMessages';
import MobileGameMenu from '@/components/MobileGameMenu/MobileGameMenu';
import MobilePlayerMat from '@/components/MobilePlayerMat/MobilePlayerMat';
import Modal from '@/components/Modal/Modal';
import NavMenu from '@/components/NavMenu/NavMenu';
import Notification from '@/components/Notification/Notification';
import OpponentSearchBar from '@/components/OpponentSearchBar/OpponentSearchBar';
import Paginator from '@/components/Paginator/Paginator';
import PasswordModal from '@/components/PasswordModal/PasswordModal';
import PasswordReset from '@/components/PasswordReset/PasswordReset';
import PlayerLabel from '@/components/PlayerLabel/PlayerLabel';
import PlayerMat from '@/components/PlayerMat/PlayerMat';
import Rank from '@/components/Rank/Rank';
import RanksDropdown from '@/components/RanksDropdown/RanksDropdown';
import Replay from '@/components/Replay/Replay';
import ReplayControls from '@/components/ReplayControls/ReplayControls';
import Room from '@/components/Room/Room';
import RoomList from '@/components/RoomList/RoomList';
import RoyalCoin from '@/components/RoyalCoin/RoyalCoin';
import Rules from '@/components/Rules/Rules';
import ScoreBoard from '@/components/ScoreBoard/ScoreBoard';
import SectionTitle from '@/components/SectionTitle/SectionTitle';
import ShareModal from '@/components/ShareModal/ShareModal';
import SettingsSummary from '@/components/SettingsSummary/SettingsSummary';
import SkillRatingModal from '@/components/SkillRatingModal/SkillRatingModal';
import Sound from '@/components/Sound/Sound';
import Spinner from '@/components/Spinner/Spinner';
import SwitchToggle from '@/components/SwitchToggle/SwitchToggle';
import TermsModal from '@/components/TermsModal/TermsModal';
import Tile from '@/components/Tile/Tile';
import Timeout from '@/components/Timeout/Timeout';
import TimeoutBlitz from '@/components/TimeoutBlitz/TimeoutBlitz';
import TimeoutMobile from '@/components/TimeoutMobile/TimeoutMobile';
import TimeoutModal from '@/components/TimeoutModal/TimeoutModal';
import TimeRemainingLabel from '@/components/TimeRemainingLabel/TimeRemainingLabel';
import ActionsLogModal from '@/components/ActionsLogModal/ActionsLogModal';
import TipJar from '@/components/TipJar/TipJar';
import Tooltip from '@/components/Tooltip/Tooltip';
import UndoModal from '@/components/UndoModal/UndoModal';
import Unit from '@/components/Unit/Unit';
import UnitCard from '@/components/UnitCard/UnitCard';
import UnitCardsModal from '@/components/UnitCardsModal/UnitCardsModal';
import UnitCoin from '@/components/UnitCoin/UnitCoin';
import UnitImage from '@/components/UnitImage/UnitImage';
import UnitGroup from '@/components/UnitGroup/UnitGroup';
import UnitStack from '@/components/UnitStack/UnitStack';
import UnitToggle from '@/components/UnitToggle/UnitToggle';
import UnitTypesSelector from '@/components/UnitTypesSelector/UnitTypesSelector';
import UnitTypesModal from '@/components/UnitTypesModal/UnitTypesModal';
import Users from '@/components/Users/Users';
import VictoryModal from '@/components/VictoryModal/VictoryModal';
import WaitingRoom from '@/components/WaitingRoom/WaitingRoom';
import { setNotifyHandler } from './plugins/notify';
import appStore from './store';
import router from './router';
import App from './App';
import { SOCKET_URL } from './helpers/env';

const vuexLocal = new VuexPersistence({
    key: 'warchest',
    storage: window.localStorage,
    reducer: state => ({
        appState: state.appState,
        chatState: state.chatState,
        loginState: state.loginState,
    }),
});

export const store = createStore({ ...appStore, plugins: [vuexLocal.plugin] });

const isProduction = process.env.NODE_ENV === 'production';
const socketPath = isProduction ? '/websocket/socket.io' : '';

const socketPlugin = new VueSocketIO({
    debug: !isProduction,
    connection: io(SOCKET_URL, {
        path: socketPath,
        transports: ['websocket'],
        secure: isProduction,
        rejectUnauthorized: false,
    }),
    vuex: {
        store,
        actionPrefix: 'SOCKET_',
        mutationPrefix: 'SOCKET_',
    },
});

library.add(faAngleDoubleLeft, faAngleDoubleRight, faAngleDown, faAngleLeft, faAngleRight,
    faArrowDown, faArrowLeft, faArrowUp, faAsterisk, faBan, faBars, faBoltLightning, faBook,
    faCaretDown, faCheck, faCheckCircle, faChevronDown, faChevronLeft, faChevronRight, faChevronUp,
    faClock, faCog, faCoins, faComment, faCompressArrowsAlt, faCopyright, faCrown,
    faEnvelope, faExclamationCircle, faFeather, faFlag, faHandPaper, faHeart, faHorseHead,
    faHourglass, faHourglassHalf, faInfoCircle, faKeyboard, faLock, faLongArrowAltDown, faLongArrowAltUp, faMobile,
    faPause, faPauseCircle, faPlay, faPlayCircle, faPlus, faPlusSquare, faQuestionCircle,
    faRecycle, faReply, faRightLeft, faScroll, faSearch, faSearchMinus, faSearchPlus, faShare, faShield, faSignInAlt,
    faSignOutAlt, faSkull, faSlash, faSmile, faSortDown, faSyncAlt, faTimes, faTimesCircle,
    faTint, faTrophy, faUndoAlt, faUser, faUserPlus, faVolumeMute, faVolumeUp, faMinus,
    faWindowMinimize, faExternalLink, faComments, faEllipsisVertical, faPersonRunning,
	faArrowTurnUp
);

const app = createApp(App);

app.use(store);
app.use(router);
app.use(Notifications);
app.use(socketPlugin);
setNotifyHandler(app.config.globalProperties.$notify);

app.component('action-modal', ActionModal);
app.component('actions-log', ActionsLog);
app.component('alt-player-label', AltPlayerLabel);
app.component('alt-units-modal', AltUnitsModal);
app.component('alt-units-selector', AltUnitsSelector);
app.component('bishop-toggle', BishopToggle);
app.component('board', Board);
app.component('block-user-modal', BlockUserModal);
app.component('cancel-modal', CancelModal);
app.component('card', Card);
app.component('cards', Cards);
app.component('chat', Chat);
app.component('circular-countdown', CircularCountdown);
app.component('contact-us', Contact);
app.component('conversation-card', ConversationCard);
app.component('count-up', CountUp);
app.component('decree-card', DecreeCard);
app.component('decrees-bar', DecreesBar);
app.component('decree-marker', DecreeMarker);
app.component('decree-widget', DecreeWidget);
app.component('decrees-modal', DecreesModal);
app.component('direct-messages-widget', DirectMessagesWidget);
app.component('disqualified-alert', DisqualifiedAlert);
app.component('draft-area', DraftArea);
app.component('fa-icon', FontAwesomeIcon);
app.component('fort-layout', FortLayout);
app.component('icon', Icon);
app.component('leaderboard', Leaderboard);
app.component('loader', Loader);
app.component('login', Login);
app.component('recent-matches', RecentMatches);
app.component('matches', Matches);
app.component('mini-direct-messages', MiniDirectMessages);
app.component('mobile-game-menu', MobileGameMenu);
app.component('mobile-player-mat', MobilePlayerMat);
app.component('modal', Modal);
app.component('nav-menu', NavMenu);
app.component('notification', Notification);
app.component('opponent-search-bar', OpponentSearchBar);
app.component('paginator', Paginator);
app.component('password-modal', PasswordModal);
app.component('password-reset', PasswordReset);
app.component('player-label', PlayerLabel);
app.component('player-mat', PlayerMat);
app.component('rank', Rank);
app.component('ranks-dropdown', RanksDropdown);
app.component('replay', Replay);
app.component('replay-controls', ReplayControls);
app.component('room', Room);
app.component('room-list', RoomList);
app.component('royal-coin', RoyalCoin);
app.component('rules', Rules);
app.component('score-board', ScoreBoard);
app.component('section-title', SectionTitle);
app.component('settings-summary', SettingsSummary);
app.component('share-modal', ShareModal);
app.component('skill-rating-modal', SkillRatingModal);
app.component('sound', Sound);
app.component('spinner', Spinner);
app.component('switch-toggle', SwitchToggle);
app.component('terms-modal', TermsModal);
app.component('tile', Tile);
app.component('timeout', Timeout);
app.component('timeout-blitz', TimeoutBlitz);
app.component('timeout-mobile', TimeoutMobile);
app.component('timeout-modal', TimeoutModal);
app.component('time-remaining-label', TimeRemainingLabel);
app.component('actions-log-modal', ActionsLogModal);
app.component('tip-jar', TipJar);
app.component('tooltip', Tooltip);
app.component('undo-modal', UndoModal);
app.component('unit', Unit);
app.component('unit-card', UnitCard);
app.component('unit-cards-modal', UnitCardsModal);
app.component('unit-coin', UnitCoin);
app.component('unit-image', UnitImage);
app.component('unit-group', UnitGroup);
app.component('unit-stack', UnitStack);
app.component('unit-toggle', UnitToggle);
app.component('unit-types-modal', UnitTypesModal);
app.component('unit-types-selector', UnitTypesSelector);
app.component('users', Users);
app.component('victory-modal', VictoryModal);
app.component('waiting-room', WaitingRoom);

app.mount('#app');

export default app;
